import { Spin } from 'antd';
import { LineChart } from '@components/charts';
import { useWidgetData } from '@hooks/useWidgetData';
import type { WidgetDefinition, WidgetRenderProps } from '@/types';

interface Config {
  color?: string;
  smooth?: boolean;
  stacked?: boolean;
  dataSet?: string;
  xColumn?: string;
  yColumn?: string;
  showGrid?: boolean;
  xAxisLabel?: string;
  yAxisLabel?: string;
  yAxisMin?: number | null;
  yAxisMax?: number | null;
}
interface Data {
  categories: string[];
  series: Array<{ name: string; data: number[] }>;
}

function LineWidget({ instance }: WidgetRenderProps<Config>) {
  const { data, isLoading } = useWidgetData<Data>(
    instance.id,
    'line',
    instance.config as Record<string, unknown>,
    instance.refreshInterval,
  );
  if (isLoading) return <Spin />;
  return (
    <LineChart
      categories={data?.categories ?? []}
      series={data?.series ?? []}
      smooth={instance.config.smooth ?? true}
      stacked={instance.config.stacked}
      color={instance.config.color}
      showGrid={instance.config.showGrid}
      xAxisLabel={instance.config.xAxisLabel}
      yAxisLabel={instance.config.yAxisLabel}
    />
  );
}

export const lineWidgetDef: WidgetDefinition<Config> = {
  type: 'line',
  name: 'Line Chart',
  description: 'Trend over time',
  icon: 'LineChartOutlined',
  category: 'chart',
  defaultTitle: 'Line Chart',
  defaultConfig: { smooth: true, showGrid: true },
  minW: 4,
  minH: 4,
  defaultW: 6,
  defaultH: 6,
  component: LineWidget,
  settingsSchema: {
    fields: [
      { key: 'smooth', label: 'Smooth line', type: 'boolean' },
      { key: 'stacked', label: 'Stacked', type: 'boolean' },
    ],
  },
};
